import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { postUserSupportTicket } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const postUserSupportTicketApi = createApi(postUserSupportTicket, "POST");

const userSupportTicketSlice = createSlice({
  name: "userSupportTicket",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postUserSupportTicketApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postUserSupportTicketApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postUserSupportTicketApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userSupportTicketSlice.reducer;
